import React from 'react'
import { Title } from '../helpers/Helper'
import { ContactContainer, ContactForm, ContactFormItem, ContactGrid, ContactInfo, ContactMobile, ContactSocial, Send, Submit } from './contactStyle'
import ImgApp from './../../assets/img/store/appstore.png'
import ImgPlay from './../../assets/img/store/playstore.png'

export default function Contact() {
  return (
    <ContactContainer id='contact'>
      <Title>Contacto</Title>
      <ContactGrid>
        <ContactInfo className='info'>
          <h3>¿En qué te podemos ayudar?</h3>
          <p>Antes de contárselo a tus followers, ¡dinos lo que piensas! Tu opinión es muy importante para nosotros. Por eso en ©Cluckin'Bell te escuchamos siempre.</p>
        </ContactInfo>
        <ContactForm className='form'>
          <ContactFormItem className='name'>
            <label htmlFor="name">Nombre:</label>
            <input type="text" id='name'/>
          </ContactFormItem>
          <ContactFormItem className='tel'>
            <label htmlFor="tel">Teléfono:</label>
            <input type="tel" id='tel'/>
          </ContactFormItem>
          <ContactFormItem className='mail'>
            <label htmlFor="mail">Correo:</label>
            <input type="mail" id='mail'/>
          </ContactFormItem>
          <ContactFormItem className='mes'>
            <label htmlFor="mes">Mensaje:</label>
            <textarea id='mes'></textarea>
          </ContactFormItem>
          <Submit className='submit'>
            <span>
              Enviar <Send/>
            </span>
          </Submit>
        </ContactForm>
        <ContactSocial className='social'>
          <h3>Descarga la aplicación</h3>
          <ContactMobile>
            <a href="#">
              <img src={ImgApp} alt="appstore"/>
            </a>
            <a href="#">
              <img src={ImgPlay} alt="playstore"/>
            </a>
          </ContactMobile>
        </ContactSocial>
      </ContactGrid>
    </ContactContainer>
  )
}
